import React, { Component } from 'react';

import { Polyline } from 'google-maps-react';

import { FilterPoles, CompareBounds } from '../../../helpers/poleHelpers';
import { FilterSpans, GetDividedSpans } from '../../../helpers/spanHelpers';


class Span extends Component {

    componentDidMount() {
        this.loadSpansList();
    }

    shouldComponentUpdate(nextProps) {
        if (this.props.ohlsList.length !== nextProps.ohlsList.length
            || this.props.zoomLevel !== nextProps.zoomLevel
            || CompareBounds(this.props.zoomLevel, this.props.bounds, nextProps.bounds)
            || this.props.isOhlListEdited !== nextProps.isOhlListEdited) {
            return true
        }
        else {
            return false;
        }
    }

    componentDidUpdate() {
        this.loadSpansList();
    }

    loadSpansList() {

        let resultList = [];
        if (this.props.zoomLevel === 2) {
            this.props.ohlsList.forEach(ohl => {

                let polesInRangeList = ohl.stubovi.filter(stub => stub.portal !== true);
                let spansInRangeList = ohl.rasponi;

                if (this.props.bounds && this.props.zoomLevel > 1) {
                    polesInRangeList = FilterPoles(ohl.stubovi, this.props.bounds);
                    spansInRangeList = FilterSpans(ohl.rasponi, this.props.bounds);
                }

                let ohlColor;
                switch (ohl.voltage) {
                    case '35':
                        ohlColor = this.props.color35;
                        break;
                    case '220':
                        ohlColor = this.props.color220;
                        break;
                    case '400':
                        ohlColor = this.props.color400;
                        break;
                    default:
                        ohlColor = this.props.color110;
                        break;
                }

                let spans = GetDividedSpans(this.props.ohlsList, polesInRangeList, spansInRangeList, ohl.position, ohl.phaseCross, ohl.name).map(span => {
                    return <Polyline
                        key={span.name + ohl.name}
                        path={span.position}
                        clicable
                        name={span.name}
                        strokeOpacity={0.8}
                        strokeColor={span.isPhaseCross ? this.props.phaseCrossColor : ohlColor}
                        onClick={this.props.onSpanClick}
                        strokeWeight={5}
                        ohlName={ohl.name}
                        ohlVoltage={ohl.voltage}
                    />
                })
                resultList = resultList.concat(spans)
            })
        }
        this.props.sendChildElementDataToState(this.props.stateElementName, resultList);
    }


    render() {
        return null;
    }

}

export default Span;